import { useUrlBuilder } from '@/composables/url-builder/index.ts'

export function getInventoryUrl (env) {
  const url = env.VUE_APP_INVENTORY_URL ?? window.location.origin.replace('://', '://inventory.')

  return useUrlBuilder(url).removeTrailingSlash().build()
}
